const cache = new Map<string, string>();
const pending = new Map<string, Promise<string>>();

/**
 * Fetches an SVG URL and returns a data URI from an in-memory cache.
 * Deduplicates in-flight requests so the same URL is never fetched twice concurrently.
 */
export async function fetchCachedSvg(url: string): Promise<string> {
  const cached = cache.get(url);
  if (cached) return cached;

  const inflight = pending.get(url);
  if (inflight) return inflight;

  const promise = fetch(url)
    .then((res) => {
      if (!res.ok) throw new Error(`SVG fetch failed: ${res.status}`);
      return res.text();
    })
    .then((svgText) => {
      const dataUri = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgText)}`;
      cache.set(url, dataUri);
      pending.delete(url);
      return dataUri;
    })
    .catch((err) => {
      pending.delete(url);
      throw err;
    });

  pending.set(url, promise);
  return promise;
}

/**
 * Returns the cached data URI for a URL if available, or undefined.
 */
export function getCachedSvg(url: string): string | undefined {
  return cache.get(url);
}
